import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TweenMax from 'TweenMax';
import 'ScrollToPlugin';
import { inject, observer } from 'mobx-react';

import Scene from '../Scene';
import Container from '../../components/Container';
import Indent from '../../components/Indent';
import { crossScreenFontSize, crossScreenPaddingTop, toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import BriefBot from './components/BriefBot/';
import mq from '@/utils/media-queries';
import introImage from './img/intro.jpg';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const PADDING_BOTTOM = 276;
const AUTO_SCROLL_TIMEOUT = 6000;

const BriefScene = styled(Scene)`
  padding-top: 0;
  padding-bottom: ${toVw(PADDING_BOTTOM)};

  ${mq.tablet(css`
    padding-bottom: ${toVwTablet(PADDING_BOTTOM)};
  `)};

  ${mq.mobile(css`
    padding-bottom: ${toVwMobile(200)};
  `)};
`;

const Intro = styled.div`
  height: 100vh;
  background: url(${introImage}) center center;
  background-size: cover;

  ${mq.tablet(css`
    height: 100vw;
  `)};
`;

const IntroContainer = styled(Container)`
  height: 100%;
`;

const IntroIndent = styled(Indent)`
  position: relative;
  height: 100%;
`;

const IntroText = styled.div`
  ${crossScreenFontSize(80)};
  position: absolute;
  bottom: ${toVw(120)};
  color: #fff;
`;

const BotContainer = styled(Container)`
  ${crossScreenPaddingTop(120)};
`;

class Brief extends React.Component {
  static propTypes = {
    isScreenDesktop: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (document.readyState === 'complete') {
      this.scrollToBot();
    } else {
      window.addEventListener('load', this.scrollToBot);
    }
  }

  scrollToBot = () => {
    if (!this.props.isScreenDesktop()) {
      return;
    }
    setTimeout(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop === 0) {
        const y = 0.2 * window.innerHeight;
        TweenMax.to(window, 1, {
          scrollTo: { y },
          ease: Power1.easeOut,
        });
      }
    }, AUTO_SCROLL_TIMEOUT);
  };

  render() {
    return (
      <BriefScene dark {...this.props}>
        <Intro>
          <IntroContainer>
            <IntroIndent>
              <IntroText>
                <AnimationOnPageLoadItem>
                  <span>
                    Hi. I’m Vitaly. <br />
                    Let’s talk?
                  </span>
                </AnimationOnPageLoadItem>
              </IntroText>
            </IntroIndent>
          </IntroContainer>
        </Intro>
        <BotContainer>
          <Indent>
            <BriefBot />
          </Indent>
        </BotContainer>
      </BriefScene>
    );
  }
}

export default inject(stores => ({
  isScreenDesktop: stores.store.envStore.isScreenDesktop,
}))(observer(Brief));



// WEBPACK FOOTER //
// ./src/scenes/Brief/index.js